import moment from 'moment';
import queryString from 'qs';

const getReportAttendanceHostDetailRequest = (filter) => {
  const queries = { limit: 10, page: filter?.page };

  if (filter?.search) queries['search'] = filter.search;
  if (filter?.userId) queries['userId'] = filter.userId;
  if (filter?.startedAt) queries['startedAt'] = moment(filter.startedAt).format('YYYY-MM-DD');
  if (filter?.endedAt) queries['endedAt'] = moment(filter.endedAt).format('YYYY-MM-DD');
  if (filter?.status?.length) queries['status'] = filter.status.map((item) => item.value).join(',');

  return queryString.stringify(queries, { skipEmptyString: true });
};

export default getReportAttendanceHostDetailRequest;
